import { Grid } from '@mui/material';
import '../healthoverview.css';
const HealthStatBox = ({ title, value, height, width }) => {
  return (
    <>
      <Grid className="health-box" style={{ height: height, width: width }}>
        <small>{title}</small>
        <span className="bold">{value}</span>
      </Grid>
    </>
  );
};

export default HealthStatBox;
